import { io } from "socket.io-client";
import { authService } from "./services";

const URL: string = process.env.REACT_APP_SOCKET_ENDPOINT || "http://localhost:8080";

export const socket = io(URL, {
  withCredentials: true,
  transports: ["websocket"], // Force WebSocket only, no polling
  auth: {
    token: authService.getToken(),
    userId: authService.getId(),
  },
});

// Add error handling
socket.on("connect_error", (error) => {
  console.error("Socket connection error details:", error.message);
});

socket.on("error", (error) => {
  console.error("Socket general error:", error);
});

socket.on("connect", () => {
  console.log("Socket connected successfully");
});

socket.on("disconnect", (reason) => {
  console.log("Socket disconnected:", reason);
});
